import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TextButton, TextButtonClassNames } from '../../../../../../commons/buttons/TextButton';
import { ReactComponent as CheckIcon } from '../../../../../../../assets/images/ArrowSaveEmail.svg';
import { ServiceEx } from '../../../../../../../models/ServicePresets';

interface DedicatedIpExSrvProps {
  serviceEx: ServiceEx;
  dedicatedIP: string;
  isDisabled: boolean;
  handleConnectStaticIP: () => void;
}

const DedicatedIpExSrv: FC<DedicatedIpExSrvProps> = ({
  serviceEx: { Price, IsConnected, Name },
  dedicatedIP,
  isDisabled,
  handleConnectStaticIP,
}) => {
  const { t } = useTranslation();
  return (
    <div className="service-card__info-container__info__additional">
      <span>
        {Name}
        {IsConnected ? ` (${Price} ${t('services.uahPerMonth')})` : null}:&nbsp;
      </span>
      {IsConnected ? (
        <span className="active connected-extra">
          {dedicatedIP}&nbsp; <CheckIcon className="icon-check" />
        </span>
      ) : (
        <TextButton
          label={`${t('buttons.addFor')} ${Price} ${t('services.uahPerMonth')}`}
          handleClick={handleConnectStaticIP}
          className={TextButtonClassNames.PrimaryActive}
          isDisabled={isDisabled}
        />
      )}
    </div>
  );
};

export default DedicatedIpExSrv;
